module.exports = __webpack_public_path__ + "static/media/bluewing_logo.e6a20569.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/details/imgs/bluewing_logo.png
// module id = 1155
// module chunks = 0